if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['base-product', 'hide-product']
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length) {
        this.closest('.shopify-section')?.remove();
        return;
      }
      
      this.innerHTML = `
        <ul class="hidden md:grid grid-cols-5 gap-4">
          ${this.filteredProducts.slice(0, 5).map((product) => `
            <li class="flex items-stretch">
              <intersection-loader 
                data-url="/products/${product}" 
                data-section-id="product-tile"
              ></intersection-loader>
            </li>
          `).join('')}
        </ul>
        <div class="relative z-[1] md:hidden">
          <swiper-container 
            free-mode="true"
            mousewheel-control="true"
            mousewheel-force-to-axis="true"
            scrollbar-enabled="true"
            scrollbar-draggable="true"
            slides-offset-after="16" 
            slides-offset-before="16" 
            space-between="4" 
            slides-per-view="1.75"
            prevent-clicks-propagation
            role="region"
            aria-label="Recently viewed products carousel"
            watch-slides-progress="true"
          >
            ${this.filteredProducts.slice(0, 4).map((product) => `
              <swiper-slide>
                <intersection-loader 
                  data-url="/products/${product}" 
                  data-section-id="product-tile"
                ></intersection-loader>    
              </swiper-slide>
            `).join('')}
          </swiper-container>
        </div>
      `;
    }

    updateLocalStorage() {
      if (localStorage.getItem('venus:recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('venus:recentlyViewedProducts')?.split(',')])].slice(0, 5) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('venus:recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}